var map = {
	"./adult/nn/wordchain-data.json": 747,
	"./adult/no/wordchain-data.json": 748,
	"./adult/se/wordchain-data.json": 749,
	"./youth/de/wordchain-data.json": 750,
	"./youth/nn/wordchain-data.json": 751,
	"./youth/no/wordchain-data.json": 752,
	"./youth/se/wordchain-data.json": 753
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 746;